


























































    import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import CreateOrderManagement from './create-ordermanagement.vue'
    import Editordermanagement from './edit-ordermanagement.vue'
     //入库订单
    class PageordermanagementRequest extends PageRequest{
        keyword:string='';
        stime:Date;
        etime:Date;
        ordtime: Date[] = [];
        status:number=-1;
        type:number=1;
    }
    
    @Component({
        components:{CreateOrderManagement,Editordermanagement}
    })
    export default class ordermanagementwarehousing extends AbpBase{
       
       edit(){
         this.getCompanyInformation_All()
            this.editModalShow=true;
           
        }

        pagerequest:PageordermanagementRequest=new PageordermanagementRequest();

        createModalShow:boolean=false;
        editModalShow:boolean=false;
        get list(){
            
            return this.$store.state.ordermanagement.list;
        };
        get loading(){
            return this.$store.state.ordermanagement.loading;
        }
        create(){
          //  this.$store.state.ordermanagement.ordertime=this.currentTime()
              this.getCompanyInformation_All()
              this.createModalShow=true;
              this.$store.state.ordermanagement.isdispose=false;
              this.$store.state.ordermanagement.type=1;
        }


        pageChange(page:number){
            this.$store.commit('ordermanagement/setCurrentPage',page);
            this.getpage();
        }
        pagesizeChange(pagesize:number){
            this.$store.commit('ordermanagement/setPageSize',pagesize);
            this.getpage();
        }
        async searchpage(){
            this.$store.state.ordermanagement.currentPage=1;
           this. getpage();
        }
        async getpage(){

            
            this.pagerequest.maxResultCount=this.pageSize;
            this.pagerequest.skipCount=(this.currentPage-1)*this.pageSize;
            if (this.pagerequest.ordtime.length > 0) {
            this.pagerequest.stime = this.pagerequest.ordtime[0];
    }
    
    if (this.pagerequest.ordtime.length > 1) {
           this.pagerequest.etime = this.pagerequest.ordtime[1];
    }

            
            await this.$store.dispatch({
                type:'ordermanagement/getAll',
                data:this.pagerequest
            })
        }
        async getCompanyInformation_All(){

              await this.$store.dispatch({
                type:'ordermanagement/getCompanyInformation',
                data:this.pagerequest
            })
        }
         async getWastetype_All(){

              await this.$store.dispatch({
                type:'ordermanagement/getWasteType',
                data:this.pagerequest
            })
        }



        get pageSize(){
            return this.$store.state.ordermanagement.pageSize;
        }
        get totalCount(){
            return this.$store.state.ordermanagement.totalCount;
        }
        get currentPage(){
            return this.$store.state.ordermanagement.currentPage;
        }
        columns=[{
            title:this.L('OrderNo'),
            key:'orderno'
        }
        ,{
            title:this.L('OrderType'),
           //key:'type'
              width:100,
            render:(h:any,params:any)=>{
                  var statustxt="";
                  var lstst=this.$store.state.ordermanagement.ordertype;
                   for(let i=0;i<lstst.length;i++){

                       if(lstst[i].id==params.row.type){
                            statustxt=this.L(lstst[i].name)
                            
                             
                         }
                   }
                      return    h('span',statustxt);
             }
        }
        
        ,{
            title:this.L('OrderWeight'),
            key:'weight',
            width:100
        }
        
,{
            title:this.L('CompanyinformationName'),
           // key:'orderTime'
             render:(h:any,params:any)=>{
               
                   var name="";
                if(params.row.companyInformation!=null){
                      name=params.row.companyInformation.name;
                }    
                return h('span',name)
            }
        }
      ,{
            title:this.L('WasteTypeName'),
          
             render:(h:any,params:any)=>{
                var wdname="";
                //params.row.  wasteType.wdname
                if(params.row.  wasteType!=null){
                      wdname=params.row.  wasteType.wdname;
                }   
                return h('span',wdname)
            }
        }
      
        
        ,{
            title:this.L('OrderOperators'),
            key:'operators',
               width:120

        },{
            title:this.L('OrderStatus'),
           width:120,
             render:(h:any,params:any)=>{
                  var statustxt="";
                  var lstst=this.$store.state.ordermanagement.statuslist;
                   for(let i=0;i<lstst.length;i++){

                       if(lstst[i].id==params.row.status){
                            statustxt=this.L(lstst[i].name)
                             
                             
                         }
                   }
                      return    h('span',statustxt);
             }
        } 
        ,{
            title:this.L('OrderTime'),
           // key:'orderTime'
             render:(h:any,params:any)=>{
                //console.log(params.row)
                return h('span',new Date(params.row.ordertime).toLocaleString())
            }
        }
        
        
        

        //
       ,{
            title:this.L('Actions'),
            key:'Actions',
            width:150,
            render:(h:any,params:any)=>{
                return h('div',[
                    h('Button',{
                        props:{
                            type:'primary',
                            size:'small'
                        },
                        style:{
                            marginRight:'5px'
                        },
                        on:{
                            click:()=>{
                                this.$store.commit('ordermanagement/edit',params.row);
                                this.edit();
                            }
                        }
                    },this.L('Edit')),
                    h('Button',{
                        props:{
                            type:'error',
                            size:'small'
                        },
                        on:{
                            click:async ()=>{
                                this.$Modal.confirm({
                                        title:this.L('Tips'),
                                        content:this.L('DeleteConfirm'),
                                        okText:this.L('Yes'),
                                        cancelText:this.L('No'),
                                        onOk:async()=>{
                                            await this.$store.dispatch({
                                                type:'ordermanagement/delete',
                                                data:params.row
                                            })
                                            await this.getpage();
                                        }
                                })
                            }
                        }
                    },this.L('Delete'))
                ])
            }
        }]
         async created(){
           // this .pagerequest.type=1;
           this.$store.state.ordermanagement.type=1;
            this.getpage();
            this.getCompanyInformation_All();
            this.getWastetype_All();
           

          
           
              
        }

        
 
        
    }
